import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { whatsappLink, telLink } from "@/lib/site";

export const FloatingButtons = () => (
  <div data-testid="floating-buttons" className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
    <motion.a
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="float-whatsapp"
      aria-label="WhatsApp"
      className="h-13 w-13 p-3.5 grid place-items-center rounded-full bg-accent text-accent-foreground shadow-lg shadow-accent/25"
    >
      <MessageCircle size={22} />
    </motion.a>
    <motion.a
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.12, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      href={telLink}
      data-testid="float-phone"
      aria-label="Telefono"
      className="h-13 w-13 p-3.5 grid place-items-center rounded-full bg-foreground text-primary-foreground shadow-lg shadow-foreground/20"
    >
      <Phone size={20} />
    </motion.a>
  </div>
);
